class ToastMessage extends HTMLElement {
  constructor() {
    super();
    this.messages = [];
  }

  connectedCallback() {
    this.render();
    document.addEventListener('show-toast', this.showToast.bind(this));
  }

  render() {
    this.innerHTML = `
      <div class="toast-container"></div>
    `;
  }

  showToast(event) {
    const message = event.detail.message;
    const type = event.detail.type || 'default';
    const duration = event.detail.duration || 10000;

    this.messages.push({ message, type, duration });

    if (this.messages.length === 1) {
      this.displayToasts();
    }
  }

  displayToasts() {
    if (this.messages.length === 0) {
      return;
    }

    const toastContainer = this.querySelector('.toast-container');

    this.messages.forEach(({ message, type, duration }) => {
      const toast = document.createElement('div');
      toast.innerHTML = message;
      toast.className = 'toast';

      if (type === 'error') {
        toast.classList.add('error');
      }

      if (type === 'info') {
        toast.classList.add('info');
      }

      toastContainer.appendChild(toast);

      setTimeout(() => {
        toast.classList.add('show');

        setTimeout(() => {
          toast.classList.remove('show');

          setTimeout(() => {
            toastContainer.removeChild(toast);
          }, 300);
        }, duration);
      }, 10);
    });
    
    this.messages = [];
  }
}

// Define the custom element tag
customElements.define('toast-message', ToastMessage);